export default __webpack_public_path__ + "static/media/pg-38.93fd4cfd.jpg";